module.exports = __webpack_public_path__ + "e596a1db342ca4c75e8bc0955b6adf29.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/grade-and-spec-data/spacer-image.png
// module id = 849
// module chunks = 0 1